/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Tag_Usage_CountInputs */



/**
* | output |
* | --- |
* | "Used on {count} project(s)" |
*
* @param {Project_Tag_Usage_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_tag_usage_count = /** @type {((inputs: Project_Tag_Usage_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tag_Usage_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verwendet von ${i?.count} Projekt(en)`)
	return /** @type {LocalizedString} */ (`Used on ${i?.count} project(s)`)
});